import { useState } from "react";
import { Link } from "react-router-dom";
import { LogOut, ExternalLink } from "lucide-react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import { useAuth } from "@/contexts/AuthContext";
import WorkshopsManager from "@/components/admin/WorkshopsManager";
import RegistrationsList from "@/components/admin/RegistrationsList";
import ContactsList from "@/components/admin/ContactsList";
import LeadsList from "@/components/admin/LeadsList";
import NewsletterList from "@/components/admin/NewsletterList";
import NotificationsList from "@/components/admin/NotificationsList";

export default function AdminDashboardPage() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("ateliers");

  return (
    <div
      data-testid="admin-dashboard"
      className="min-h-screen bg-[#FAF7F8] text-[#1E1E2A]"
    >
      <header className="sticky top-0 z-30 bg-[#FAF7F8]/90 backdrop-blur-xl border-b border-[#DDD7E2]/60">
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between gap-4">
          <div className="flex flex-col leading-tight">
            <span className="font-serif-display text-2xl">Espace administration</span>
            <span className="text-[10px] tracking-[0.25em] uppercase text-[#5F6170] mt-0.5">
              Connecté · {user?.email}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Link
              to="/"
              data-testid="admin-view-site"
              className="hidden sm:inline-flex items-center gap-2 text-sm text-[#5F6170] hover:text-[#2847B8] transition-colors px-4 py-2 rounded-full"
            >
              <ExternalLink className="w-4 h-4" />
              Voir le site
            </Link>
            <button
              onClick={logout}
              data-testid="admin-logout"
              className="inline-flex items-center gap-2 text-sm bg-white border border-[#DDD7E2] hover:border-[#C98FA3] text-[#1E1E2A] rounded-full px-4 py-2 transition-colors"
            >
              <LogOut className="w-4 h-4" />
              Se déconnecter
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 md:px-12 py-10 md:py-14">
        <Tabs value={tab} onValueChange={setTab} className="w-full">
          <TabsList
            data-testid="admin-tabs"
            className="bg-white border border-[#DDD7E2] rounded-full p-1.5 h-auto flex flex-wrap justify-start gap-1"
          >
            <TabsTrigger
              value="ateliers"
              data-testid="admin-tab-ateliers"
              className="rounded-full px-5 py-2 text-sm data-[state=active]:bg-[#2847B8] data-[state=active]:text-white"
            >
              Ateliers
            </TabsTrigger>
            <TabsTrigger
              value="inscriptions"
              data-testid="admin-tab-inscriptions"
              className="rounded-full px-5 py-2 text-sm data-[state=active]:bg-[#2847B8] data-[state=active]:text-white"
            >
              Inscriptions
            </TabsTrigger>
            <TabsTrigger
              value="contacts"
              data-testid="admin-tab-contacts"
              className="rounded-full px-5 py-2 text-sm data-[state=active]:bg-[#2847B8] data-[state=active]:text-white"
            >
              Demandes RDV
            </TabsTrigger>
            <TabsTrigger
              value="leads"
              data-testid="admin-tab-leads"
              className="rounded-full px-5 py-2 text-sm data-[state=active]:bg-[#2847B8] data-[state=active]:text-white"
            >
              Lead magnet
            </TabsTrigger>
            <TabsTrigger
              value="newsletter"
              data-testid="admin-tab-newsletter"
              className="rounded-full px-5 py-2 text-sm data-[state=active]:bg-[#2847B8] data-[state=active]:text-white"
            >
              Newsletter
            </TabsTrigger>
            <TabsTrigger
              value="notifications"
              data-testid="admin-tab-notifications"
              className="rounded-full px-5 py-2 text-sm data-[state=active]:bg-[#2847B8] data-[state=active]:text-white"
            >
              Listes d'attente
            </TabsTrigger>
          </TabsList>

          <TabsContent value="ateliers" className="mt-8">
            <WorkshopsManager />
          </TabsContent>
          <TabsContent value="inscriptions" className="mt-8">
            <RegistrationsList />
          </TabsContent>
          <TabsContent value="contacts" className="mt-8">
            <ContactsList />
          </TabsContent>
          <TabsContent value="leads" className="mt-8">
            <LeadsList />
          </TabsContent>
          <TabsContent value="newsletter" className="mt-8">
            <NewsletterList />
          </TabsContent>
          <TabsContent value="notifications" className="mt-8">
            <NotificationsList />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
